export async function createStripeBulkPaymentIntent(
  total: number,
  baseAmount: number,
  fee: number,
  invoices: string,
  instanceType: string,
  method: string,
) {
  const response = await fetch('/api/payments/account/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      invoices,
      total,
      baseAmount,
      fee,
      instanceType,
      method,
    }),
  })

  const intent = await response.json()

  return intent as IntentInfo
}

export async function updateStripeBulkPaymentIntent(
  intentId: string,
  total: number,
  baseAmount: number,
  fee: number,
  invoices: string,
  instanceType: string,
  method: string,
) {
  const response = await fetch(`/api/payments/account/${intentId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      total,
      baseAmount,
      fee,
      invoices,
      instanceType,
      method,
    }),
  })

  const intent = await response.json()

  return intent as IntentInfo
}

export async function createPaymentLinkPaymentIntent(
  paymentLinkCode: string,
  total: number,
  baseAmount: number,
  fee: number,
  invoices: string,
  instanceType: string,
  method: string,
) {
  const response = await fetch(
    `/api/paymentlinks/${paymentLinkCode}/payments/create`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        invoices,
        total,
        baseAmount,
        fee,
        instanceType,
        method,
      }),
    },
  )

  if (!response.ok) {
    // Some error responses (e.g. sendStatus) have no JSON body
    const body = await response.json().catch(() => null)
    throw new Error(body?.error ?? 'Unable to create payment.')
  }

  const intent = await response.json()

  return intent as IntentInfo
}

export async function updateStripePaymentLinkPaymentIntent(
  paymentLinkCode: string,
  intentId: string,
  total: number,
  baseAmount: number,
  fee: number,
  invoices: string,
  instanceType: string,
  method: string,
) {
  const response = await fetch(
    `/api/paymentlinks/${paymentLinkCode}/payments/${intentId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        paymentLinkCode,
        total,
        baseAmount,
        fee,
        invoices,
        instanceType,
        method,
      }),
    },
  )

  const intent = await response.json()

  return intent as IntentInfo
}
